import React from 'react';

const ScrollToBottomButton = ({ visible, onClick }) => (
    <div
        className={`pointer-events-none absolute bottom-[104px] left-1/2 z-50 -translate-x-1/2 transition-all duration-200 ease-out md:bottom-[132px] ${
            visible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
        }`}
        aria-hidden={!visible}
    >
        <button
            type="button"
            onClick={onClick}
            tabIndex={visible ? 0 : -1}
            aria-label="Scroll to latest message"
            className={`pointer-events-auto group flex h-11 w-11 items-center justify-center rounded-full border border-white/25 bg-[#414141]/75 text-white shadow-[0_10px_28px_rgba(20,20,20,0.24)] backdrop-blur-xl transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#414141]/85 hover:shadow-[0_14px_34px_rgba(20,20,20,0.30)] focus:outline-none focus:ring-2 focus:ring-[#D81F26] focus:ring-offset-2 focus:ring-offset-transparent active:translate-y-0 ${
                visible ? '' : 'pointer-events-none'
            }`}
        >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" className="transition-transform duration-200 group-hover:translate-y-0.5">
                <path d="m6 9 6 6 6-6" />
            </svg>
        </button>
    </div>
);

export default ScrollToBottomButton;
